"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import BaseToolbarButtonProp from "./BaseToolbarButton";
import { Messages } from "Messages";
import { System } from "Constants/objects";

var AddButtonProps =
/*#__PURE__*/
function (_BaseToolbarButtonPro) {
  _inherits(AddButtonProps, _BaseToolbarButtonPro);

  function AddButtonProps(_ref) {
    var _this;

    var isContextMenu = _ref.isContextMenu,
        title = _ref.title,
        onMouseDown = _ref.onMouseDown,
        rest = _objectWithoutProperties(_ref, ["isContextMenu", "title", "onMouseDown"]);

    _classCallCheck(this, AddButtonProps);

    var props = _objectSpread({
      isContextMenu: isContextMenu,
      text: title || Messages.Controls.Add,
      hint: title || Messages.Controls.Add,
      elementAttr: {
        'class': System.TOOLBAR_BTN_CLASSES.ADD
      }
    }, rest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AddButtonProps).call(this, props));

    _this.setOptions({
      iconType: _this.getOptions().iconType || 'material:add_circle_outline',
      mouseDown: _this.getOptions().mouseDown || onMouseDown
    });

    return _this;
  }

  _createClass(AddButtonProps, [{
    key: "onMouseDown",
    value: function onMouseDown(element) {
      var _this$getOptions = this.getOptions(),
          mouseDown = _this$getOptions.mouseDown;

      if (typeof mouseDown === "function") {
        $(element).off('mousedown');
        $(element).on('mousedown', function (e) {
          mouseDown(e);
        });
      }
    }
  }]);

  return AddButtonProps;
}(BaseToolbarButtonProp);

_defineProperty(AddButtonProps, "create", function (options) {
  return new AddButtonProps(options).props();
});

export { AddButtonProps as default };